import Choices from 'choices.js';

export default (() => {
    const elements = Array.from(document.querySelectorAll('.js-select-hrefs'));

    elements.forEach((element) => {
        new Choices(element, {
            searchEnabled: false,
            placeholder: true,
            shouldSort: false
        });

        element.addEventListener('choice', (e) => {
            const value = e.detail.choice.value;
            if (value) {
                window.location.href = value;
            }
        });
    });
})();
